const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Blog Posts
export const fetchBlogPosts = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/blog/posts/`);
    if (!response.ok) throw new Error('Failed to fetch blog posts');
    return await response.json();
  } catch (error) {
    console.error('Error fetching blog posts:', error);
    throw error;
  }
};

export const fetchBlogPostDetails = async (postId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/blog/posts/${postId}/`);
    if (!response.ok) {
      throw new Error(`Failed to fetch details for blog post with ID ${postId}`);
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const addBlogPost = async (formData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/blog/posts/`, {
      method: 'POST',
      body: formData, // FormData already includes the files
    });
    if (!response.ok) throw new Error('Failed to add blog post');
    return await response.json();
  } catch (error) {
    console.error('Error adding blog post:', error);
    throw error;
  }
};

export const updateBlogPost = async (id, formData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/blog/posts/${id}/`, {
      method: 'PUT',
      body: formData, // FormData already includes the files
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ [AdminBlogService] Response error:', errorText);
      throw new Error('Failed to update blog post');
    }
    
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('❌ [AdminBlogService] Error in updateBlogPost:', error);
    throw error;
  }
};

export const deleteBlogPost = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/blog/posts/${id}/`, {
      method: 'DELETE',
    });
    if (!response.ok) throw new Error('Failed to delete blog post');
    return true;
  } catch (error) {
    console.error('Error deleting blog post:', error);
    throw error;
  }
};

export const bulkDeleteBlogPosts = async (postIds) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/blog/posts/bulk-delete/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ post_ids: postIds }),
    });
    if (!response.ok) throw new Error('Failed to bulk delete blog posts');
    return await response.json();
  } catch (error) {
    console.error('Error bulk deleting blog posts:', error);
    throw error;
  }
};

// Blog Categories
export const fetchBlogCategories = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/blog/categories/`);
    if (!response.ok) throw new Error('Failed to fetch blog categories');
    return await response.json();
  } catch (error) {
    console.error('Error fetching blog categories:', error);
    throw error;
  }
};

export const fetchBlogCategoryDetails = async (categoryId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/blog/categories/${categoryId}/`);
    if (!response.ok) {
      throw new Error(`Failed to fetch details for blog category with ID ${categoryId}`);
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const addBlogCategory = async (categoryData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/blog/categories/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(categoryData),
    });
    if (!response.ok) throw new Error('Failed to add blog category');
    return await response.json();
  } catch (error) {
    console.error('Error adding blog category:', error);
    throw error;
  }
};

export const updateBlogCategory = async (id, categoryData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/blog/categories/${id}/`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(categoryData),
    });
    if (!response.ok) throw new Error('Failed to update blog category');
    return await response.json();
  } catch (error) {
    console.error('Error updating blog category:', error);
    throw error;
  }
};

export const deleteBlogCategory = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/blog/categories/${id}/`, {
      method: 'DELETE',
    });
    if (!response.ok) throw new Error('Failed to delete blog category');
    return true;
  } catch (error) {
    console.error('Error deleting blog category:', error);
    throw error;
  }
};

export const bulkDeleteBlogCategories = async (categoryIds) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/blog/categories/bulk-delete/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ category_ids: categoryIds }),
    });
    if (!response.ok) throw new Error('Failed to bulk delete blog categories');
    return await response.json();
  } catch (error) {
    console.error('Error bulk deleting blog categories:', error);
    throw error;
  }
};

// Blog Statistics
export const fetchBlogStatistics = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/blog/statistics/`);
    if (!response.ok) throw new Error('Failed to fetch blog statistics');
    return await response.json();
  } catch (error) {
    console.error('Error fetching blog statistics:', error);
    throw error;
  }
}; 